import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'
import Attachment from 'components/global/icons/Attachment'

const AttachmentLink = ({ attachment, onClick }) =>
  onClick ? (
    <Text
      typography="caption12"
      className="attachment"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <Attachment color="black" />
      {attachment.file_name || attachment.name || I18n.t('attachment')}
    </Text>
  ) : (
    <a
      style={{ alignItems: 'center', gap: '10px' }}
      className="attachment"
      href={attachment.file || attachment.url}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Attachment color="black" />
      {attachment.file_name || attachment.name || I18n.t('attachment')}
    </a>
  )

AttachmentLink.propTypes = {
  onClick: PropTypes.func,
  attachment: PropTypes.shape(),
}

export default AttachmentLink
